import axios, { Axios } from "axios";

const url =
  "https://travel-advisor.p.rapidapi.com/restaurants/list-in-boundary";

export const getData = async (type, sw, ne) => {
  try {
    const res = await axios.get(
      `https://travel-advisor.p.rapidapi.com/${type}/list-in-boundary`,
      {
        method: "GET",
        params: {
          bl_latitude: sw.lat,
          tr_latitude: ne.lat,
          bl_longitude: sw.lng,
          tr_longitude: ne.lng,
        },
        headers: {
          "x-rapidapi-host": "travel-advisor.p.rapidapi.com",
          "x-rapidapi-key":
            process.env.REACT_APP_TRAVEL_API_KEY,
        },
      }
    );
    return res.data["data"];
  } catch (error) {
    console.log(error.message);
  }
};

export const getWeatherData = async (lat, lng) => {
  try {
    const res = await axios.get(
      `https://community-open-weather-map.p.rapidapi.com/find`,
      {
        method: "GET",
        params: {
          lon: lng,
          lat: lat,
        },
        headers: {
          "x-rapidapi-host": "community-open-weather-map.p.rapidapi.com",
          "x-rapidapi-key":
          process.env.REACT_APP_WEATHER_API_KEY,
        },
      }
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};
